<template>
  <UserDrawer ref="drawerComponent" v-model="drawer" @user-added="callApi" v-model:editUser="editUser" />
  <ChangePassword ref="drawerComponentPassword" v-model="drawerPassword" v-model:editUser="editUser" />
  <v-container>
    <div class="exploration-table">
      <div class="table-top-content">
        <div class="d-flex align-center">
          <div class="title"><span class="userCount">{{ filteredUsers.length }} users</span>Manage your users here</div>
        </div>
        <div>
          <div class="test-pdf-div">
            <v-btn class="pdf-btn" @click="openSideModal">
              <span><v-icon size="16">mdi-plus</v-icon> <span></span> Add User</span>
            </v-btn>
          </div>
        </div>
      </div>
      <!-- Search Input -->
      <div class="search-container">
        <v-text-field
          v-model="searchQuery"
          placeholder="Search users, roles, tenants, usernames..."
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          density="compact"
          clearable
          hide-details
          class="search-input"
        ></v-text-field>
      </div>
      <!-- Add a scrollable wrapper around the table -->
      <div class="table-scroll-wrapper">
        <v-data-table-server v-model:items-per-page="itemsPerPage" :headers="headers" :items="filteredUsers"
          :items-per-page-options="pageOptions" :items-length="filteredUsers.length" :loading="loading" item-value="name"
          @update:options="handlePageChange" fixed-header :height="tableScrollHeight">
          <template v-slot:loader>
            <v-skeleton-loader type="table-row-divider" :loading="loading" :types="{
              'table-row-divider': {
                height: 'calc(100vh - 425px)',
                rows: 5
              }
            }" style="background-color: #ffffff;">
            </v-skeleton-loader>
          </template>
          <template v-slot:headers>
            <tr>
              <th v-for="header in headers" :key="header.value" class="text-left search-dropdown-menu header-cell"
                :style="{ backgroundColor: 'transparent' }">
                <div class="d-flex align-center justify-space-between">
                  <div class="sort-icon-title d-flex align-center" style="gap: 10px">
                    <!-- <div class="sort-icons">
                      <div class="img-div">
                        <img :src="sort_up" alt="sort-up" class="cursor-pointer" @click="sort(header.title, 'asc')" />
                      </div>
                      <div class="img-div">
                        <img :src="sort_down" alt="sort-down" class="cursor-pointer"
                          @click="sort(header.title, 'desc')" />
                      </div>
                    </div> -->
                    {{ header.title }}
                  </div>
                </div>
              </th>
            </tr>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <div class="user-container d-flex align-center">
                  <!-- User Avatar with Microsoft Icon -->
                  <div class="user-avatar">
                    <v-avatar size="40" class="user-avatar-img">
                      <v-img :src=userImage alt="User Avatar"></v-img>
                    </v-avatar>
                    <v-img  v-if="item.loginType != 'local'" :src=companyIcon alt="Microsoft Logo" class="ms-icon ms-icon-img" width="16" height="16" />
                  </div>
                  <!-- User Details -->
                  <div class="user-details">
                    <div class="d-flex align-center">
                      <span class="user-name-table">{{ item.firstName }} {{ item.lastName }}</span>
                      <v-chip class="status-chip" color="#ABEFC6"
                        text-color="#067647" size="small">
                        Active
                      </v-chip>
                      <!-- <v-chip v-else class="status-chip" color="red-lighten-4" text-color="red-darken-2" size="small">
                        Inactive
                      </v-chip> -->
                    </div>
                    <span class="user-username">{{ item.username }}</span>
                  </div>
                </div>
              </td>
              <td>
                <span v-if="item.role" class="clickable-cell no-bg">{{ item.role }}</span>
              </td>
              <td>
                <span v-for="tenant in item.tenants" :key="tenant.id" class="clickable-cell no-bg">
                  {{ tenant.name }}
                </span>
              </td>
              <td>
                <v-menu offset-y>
                  <template v-slot:activator="{ props }">
                    <v-btn variant="text" class="float-right" v-bind="props">
                      <img :src="elipse" />
                    </v-btn>
                  </template>
                  <v-list dense class="custom-list">
                    <v-list-item @click="editUserModal(item)" class="custom-list-item">
                      <v-list-item-content class="d-flex align-center">
                        <img class="mr-2 icon-size" :src="pencil" />
                        <v-list-item-title>Edit</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="openChangePasswordModal(item)" class="custom-list-item">
                      <v-list-item-content class="d-flex align-center">
                        <img class="mr-2 icon-size" :src="changePass" />
                        <v-list-item-title>Change Password</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="showDeleteConfirmation(item)" class="custom-list-item">
                      <v-list-item-content class="d-flex align-center">
                        <img class="mr-2 icon-size" :src="delete_icon" />
                        <v-list-item-title>Delete</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>
          <template v-slot:footer>
            <v-row class="mt-2" align="center" justify="space-between">
              <v-btn icon :disabled="page === 1" @click="prevPage">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn icon :disabled="page === numberOfPages" @click="nextPage">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </v-row>
          </template>
          <template v-slot:no-data>
            <div class="d-flex justify-center align-center pa-4">
              No data available
            </div>
          </template>
        </v-data-table-server>
      </div>
    </div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
    
    <!-- Delete Confirmation Modal -->
    <v-dialog transition="dialog-top-transition" v-model="confirmDeleteDialog" width="417">
      <div class="cross-btn-div" @click="closeDeleteConfirmation">
        <v-img :src="close_icon" alt="close"></v-img>
      </div>
      <v-alert title="Delete User" :text="confirmDeleteText">
        <div class="alert-btns-div">
          <v-btn class="cancel-btn" flat @click="closeDeleteConfirmation">Cancel</v-btn>
          <v-btn class="delete-btn" flat @click="confirmDeleteUser" :loading="deleteLoading">
            <v-img :src="delete_icon" alt="delete-icon" width="16" height="15" class="mr-2"></v-img>
            Delete User</v-btn>
        </div>
      </v-alert>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "../../../axiosInterceptor";
import axios from "axios";
import UserDrawer from "@/components/layout/Users/UserDrawer.vue";
import ChangePassword from "./ChangePassword.vue";
export default {
  name: "TableData",
  components: {
    UserDrawer,
    ChangePassword
  },
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sort_up: require("../../../assets/Svg/Table/up.svg"),
      sort_down: require("../../../assets/Svg/Table/down.svg"),
      reset_icon: require("../../../assets/Images/reset.png"),
      close_icon: require("../../../assets/Images/close-circle.png"),
      elipse: require("../../../assets/Svg/elipse.svg"),
      pencil: require("../../../assets/Svg/Dashboard/pencil.svg"),
      delete_icon: require("../../../assets/Svg/Dashboard/delete.svg"),
      userImage: require("../../../assets/Images/Navbar/profile.png"),
      companyIcon: require("../../../assets/Svg/companyIcon.svg"),
      changePass: require("../../../assets/Svg/changePass.svg"),
      itemsPerPage: localStorage.getItem('itemsPerPage') || 20,
      headers: [
        { title: 'User', key: 'firstname', sortable: false },
        { title: 'Roles', key: 'roles', sortable: false },
        { title: 'Tenant', key: 'tenant', sortable: false },
        { title: 'Actions', key: 'action', sortable: false }
      ],
      totalItems: 0,
      page: 1,
      pageOptions: [20, 50, 100, 200, 300, 400, 500],
      searchQuery: '',
      searchLoading: false,
      loadingCsv: false,
      drawer: false,
      drawerPassword: false,
      user: {
        name: '',
        email: '',
        role: '',
      },
      snackbar: {
        visible: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
      editUser: "",
      confirmDeleteDialog: false,
      confirmDeleteText: "",
      deleteLoading: false,
      selectedUser: null
    };
  },
  computed: {
    tableScrollHeight() {
      return "auto";
    },
    serverItems() {
      return this.users; // Directly mapping props to computed property
    },
    filteredUsers() {
      if (!this.searchQuery) {
        return this.users;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.users.filter(user => {
        const firstNameMatch = user.firstName && user.firstName.toLowerCase().includes(query);
        
        const lastNameMatch = user.lastName && user.lastName.toLowerCase().includes(query);
        
        const usernameMatch = user.username && user.username.toLowerCase().includes(query);
        
        const roleMatch = user.role && user.role.toLowerCase().includes(query);
        
        const tenantsMatch = user.tenants && user.tenants.some(tenant => 
          tenant.name && tenant.name.toLowerCase().includes(query)
        );
        
        return firstNameMatch || lastNameMatch || usernameMatch || roleMatch || tenantsMatch;
      });
    }
  },
  methods: {
    callApi() {
      this.$emit("user-api-call");
    },
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    openSideModal() {
      this.$refs.drawerComponent.resetForm();
      this.editUser = null;
      this.drawer = true;
    },
    openChangePasswordModal(item) {
      this.editUser = item
      this.drawerPassword = true;
    },
    editUserModal(item) {
      this.editUser = item
      this.drawer = true;
    },
    handlePageChange({ page, itemsPerPage }) {
      this.$emit('update:pagination', { page, itemsPerPage });
      localStorage.setItem('itemsPerPage', itemsPerPage);
    },
    prevPage() {
      if (this.page > 1) {
        this.page--;
      }
    },
    nextPage() {
      if (this.page < this.numberOfPages) {
        this.page++;
      }
    },
    showDeleteConfirmation(item) {
      this.selectedUser = item;
      this.confirmDeleteText = `Are you sure you want to delete the user "${item.firstName} ${item.lastName}"? This action cannot be undone.`;
      this.confirmDeleteDialog = true;
    },
    closeDeleteConfirmation() {
      this.confirmDeleteDialog = false;
      this.selectedUser = null;
      this.deleteLoading = false;
    },
    async confirmDeleteUser() {
      if (!this.selectedUser) return;
      
      this.deleteLoading = true;
      const userId = this.selectedUser.id;

      try {
        const response = await api.delete(`${process.env.VUE_APP_API_URL}public/api/admin/users/${userId}`);

        if (response && response.data) {
          if (response.data.statusCode === 200 || response.data.statusCode === 201) {
            this.showSnackbar(response.data.message || "User deleted successfully!", "success");
            this.$emit("user-api-call");
            this.closeDeleteConfirmation();
          } else {
            this.showSnackbar(response.data.message || "Error deleting user", "error");
          }
        } else {
          this.showSnackbar("Unexpected response from server", "error");
        }
      } catch (error) {
        this.showSnackbar(error.response?.data?.message || "Error deleting user", "error");
      } finally {
        this.deleteLoading = false;
      }
    }

  },
  watch: {
    users: {
      handler(newVal) {
        this.totalItems = newVal.length; // Update total items count
      },
      immediate: true,
      deep: true
    }
  }
};
</script>


<style scoped>
.exploration-table {
  position: relative;
}

.table-scroll-wrapper {
  height: calc(100vh - 200px);
  overflow-y: auto;
  background: #fff;
  border-radius: 8px;
}

.table-title {
  font-size: 23.50px;
  font-weight: bold;
  margin-bottom: 10px;
}

.applied-filters {
  font-size: 13.50px;
  font-weight: 600;
  line-height: 16px;
  color: #FFFFFF;
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: "Inter", sans-serif !important;
}

.applied-filters>span {
  margin-right: 10px;
  border-right: 1px solid #FFFFFF;
  padding-right: 10px;
  font-size: 11.50px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.2px;
}

.applied-filters span:nth-child(5) {
  border-right: none !important;
}

.test-links {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-dropdown {
  background: white;
  width: 100%;
  border-radius: 4px;
  max-height: 200px;
}

.custom-list {
  width: auto;
}

.custom-list-item {
  min-width: fit-content;
}

.icon-size {
  width: 18px;
  height: 18px;
}

.v-list-item-title {
  width: 100px !important;
}

.user-container {
  display: flex;
  align-items: center;
  gap: 12px;
  /* Spacing between avatar and details */
  padding: 8px;
  border-radius: 8px;
}

.user-avatar {
  position: relative;
  width: 40px;
  height: 40px;
}

.ms-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  background-color: white;
  border-radius: 50%;
  padding: 5px;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name-table {
  font-size: 11.5px;
}

.user-username {
  font-weight: 300;
  color: #6c757d;
  font-size: 10px;
}

.status-chip {
  border-radius: 12px;
  font-size: 0.60rem;
  margin-left: 8px;
}

/* Override v-data-table__thead positioning for this component */
:deep(.v-data-table__thead) {
  top: 0px !important;
}
.v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {
  top: 0px !important;
}

/* Override th positioning within thead for this component */
:deep(.v-data-table__thead th) {
  top: 0px !important;
}

/* Ensure headers are visible and properly styled */
.header-cell {
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 16px !important;
  border: none !important;
}

.dark-mode .v-data-table__tbody .v-btn__content img, .v-list-item__content img {
    filter: brightness(0) invert(1) !important;
}

.v-list-item--density-default.v-list-item--one-line
{
  min-height: 0px !important;
  padding: 0px !important;
  margin: 6px 8px !important;
}

.clickable-cell
{
  margin: 4px 0px !important;
}

/* Search container styling */
.search-container {
  margin: 6px;
}

.search-input {
  width: 100%;
}

.search-input :deep(.v-field__outline) {
  border-color: #e0e0e0;
}

.search-input :deep(.v-field--focused .v-field__outline) {
  border-color: #1976d2;
}

.pdf-btn
{
  width: 100% !important;
}

</style>